// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] || chunkId) + "-" + {"245":"f73443f889550b5d5e08","453":"55de012d1a5355779e41","577":"f228f548d8a114a1ad44"}[chunkId] + ".js";
};